// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__vEJLI"};